import { keepPreviousData, useQuery } from '@tanstack/react-query'
import { getCalendarService, type CalendarParams } from '@/services/calendar'

export const calendarQueryKey = (params: CalendarParams) => ['calendar', params]

export const useCalendar = (params: CalendarParams) =>
  useQuery({
    queryKey: calendarQueryKey(params),
    queryFn: () => getCalendarService(params),
    placeholderData: keepPreviousData,
  })
